import { useMutation } from '@tanstack/react-query';
import { runSimulation } from '../api/client';
import type { SimulationRequest } from '../types';

export function useSimulation() {
  return useMutation({
    mutationFn: (request: SimulationRequest) => runSimulation(request),
  });
}
